export const getEnv = (varName: string) => {
	return (global as any)[varName] === `{{${varName}}}`
		? process.env[`REACT_APP_${varName}`]
		: (global as any)[varName]
}
